module.exports = __webpack_public_path__ + "img/feedback3.c4c6d401.webp";